import { render, staticRenderFns } from "./QuestionAnswerDetailsModal.vue?vue&type=template&id=0a2161f9&lang=pug"
import script from "./QuestionAnswerDetailsModal.vue?vue&type=script&lang=ts"
export * from "./QuestionAnswerDetailsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports